import React, { FC } from "react";

import { TFilterWithData, ThemeProvider } from "../../../components";
import { desktopFilterItems } from "../../../mock/filtersMock";
import { renderFilter } from "../RenderFilterStrategy";
import useFilter from "../useFilter";

const DesktopFilters: FC = () => {
  const filterData = useFilter({
    filterItems: desktopFilterItems as TFilterWithData[],
  });
  const { filterItemsState, handleFiltersChange } = filterData;

  return (
    <ThemeProvider theme="light">
      <div className="filter-side">
        {filterItemsState.map((filter) =>
          renderFilter({ filter, onFilterChange: handleFiltersChange }),
        )}
      </div>
    </ThemeProvider>
  );
};

export default DesktopFilters;
